import getStore from '../store';
import isTemplateProject from '../utils/isTemplateProject';

export default function getProjects(appName?: string, getNonAppSpecificProjects?: boolean) {
    return [...getStore().projects.values()]
        .filter(p => {
            const shouldShowProject = !p.deleted && !isTemplateProject(p.projectId);
            if (appName) {
                return (
                    shouldShowProject &&
                    (p.appName === appName || (getNonAppSpecificProjects && !p.appName))
                );
            }
            return shouldShowProject && !p.appName;
        })
        .sort((a, b) => compare(a.name, b.name));
}

function compare(a: string | null, b: string | null): number {
    return (a || '').localeCompare(b || '');
}
